module.exports = __webpack_public_path__ + "static/bg-mountains-a-5978672c34ef4dcb48c7a2248275691d.jpg";